import Radio from "../../Radio";
import type PlayerFactory from "./PlayerFactory";

class AudioStrategy {
  private Players!: PlayerFactory;

  constructor(Players: PlayerFactory) {
    this.Players = Players;
  }

  async connect() {
    const players = this.Players.getAll();

    try {
      for (const player of players) {
        if (player instanceof HTMLVideoElement) {
          const radio = new Radio();
          radio.GlobalAudio.connectVideoAudio(player, player.id);
          radio.GlobalAudio.resume();
        }
      }
    } catch (error) {
      console.error("[StrategyAudio] Error to connect audio:", error);
    }

    return this;
  }

  disconnect() {
    const radio = new Radio();
    const players = this.Players.getAll();
    for (const player of players) {
      if (player instanceof HTMLVideoElement) {
        radio.GlobalAudio.disconnectVideoAudio(player.id);
      }
    }
  }
}
export default AudioStrategy;
